import { Reveal } from "@/components/Reveal";

const steps = [
  { nr: "1", title: "Formular ausfüllen", text: "Vier Angaben, weniger als 30 Sekunden." },
  { nr: "2", title: "Sofortbonus erhalten", text: "Dein Steuer-Sparpaket 2027 kommt direkt per E-Mail." },
  { nr: "3", title: "Bei allen Ziehungen dabei sein", text: "Du bleibst automatisch für jede kommende Ziehung qualifiziert." },
];

export const Steps = () => (
  <section id="so-gehts" className="scroll-mt-20 bg-paper py-16 md:py-24" data-testid="steps-section">
    <div className="mx-auto max-w-[1180px] px-5">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold-dark">Teilnahme</p>
        <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-ink md:text-5xl">
          So einfach geht's.
        </h2>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
        {steps.map((s, i) => (
          <Reveal key={s.nr} delay={i * 0.1}>
            <div
              className="h-full rounded-[18px] border border-line bg-white p-7 shadow-[0_10px_30px_rgba(17,17,17,0.05)]"
              data-testid={`step-card-${i + 1}`}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold font-display text-lg font-extrabold text-ink">{s.nr}</span>
              <h3 className="mt-5 font-display text-lg font-bold text-ink">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-mutedlight">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
